import { FC } from 'react';
import { Box, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
// components
import { LayoutContainer } from '../Auth/LayoutContainer';
import { AccessDeniedIcon } from 'assets/svgs';
// constants, styles
import { textTransform } from 'styles/commonComponentStyle';
import { AUTH_LINKS, GO_TO_HOME_TEXT, ACCESS_DENIED_TEXT, ACCESS_DENIED_MSG_TEXT } from 'constants/index';

const AccessDenied: FC = () => {
  const navigate = useNavigate();

  return (
    <LayoutContainer title={ACCESS_DENIED_TEXT} subTitle={ACCESS_DENIED_MSG_TEXT}>
      <Box display="flex" flexDirection="column" alignItems="center">
        <Box mt={5} mb={10}>
          <AccessDeniedIcon />
        </Box>

        <Button variant="contained" sx={textTransform} onClick={() => navigate(AUTH_LINKS.LOGIN_LINK)}>
          {GO_TO_HOME_TEXT}
        </Button>
      </Box>
    </LayoutContainer>
  );
};

export default AccessDenied;
